import React, { Component, Fragment } from "react";
import classNames from "classnames";
import isEmpty from "is-empty";

import StringValidations from "../../../utils/StringValidations";

import { closeModal } from '../../shared/components/layouts/OldModal';

import TextInput from "../../shared/components/forms/TextInput";
import NumberInput from "../../shared/components/forms/NumberInput";
import {segmentEventTracker} from "../../../utils/SegmentEventTracker";
import {TrackEventName} from "../../shared/constants/SegmentEvents";

class ContactManagerFormContainer extends Component {
  state = {
    id: null,
    first_name: null,
    last_name: null,
    email_address: null,
    work_contact_number: null,
    work_contact_number_extension: null,
    personal_contact_number: null,
    errors: {},
    is_duplicate_error: false,
    submitting: false,
  };

  componentDidMount() {
    if (!isEmpty(this.props.contact)) {
      this.setState({
        id: this.props.contact.id,
        first_name: this.props.contact.first_name,
        last_name: this.props.contact.last_name,
        email_address: this.props.contact.email_address,
        work_contact_number: this.props.contact.work_contact_number,
        personal_contact_number: this.props.contact.personal_contact_number,
        work_contact_number_extension: this.props.contact.work_contact_number_extension,
      });
    }
  }

  get newContact() {
    return {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email_address: this.state.email_address,
      personal_contact_number: this.state.personal_contact_number,
      work_contact_number: this.state.work_contact_number,
      work_contact_number_extension: this.state.work_contact_number_extension,
    };
  }

  get emailRegex() {
    return StringValidations.emailValidationRegex();
  }

  saveButtonClassnames() {
    return classNames(
      "ds-btn",
      "--medium",
      "_flexRight",
      {"-disabled": this.isButtonDisabled()},
    );
  }

  validateEmail = () => {
    const { email_address } = this.state;
    if (!email_address || this.emailRegex.test(email_address)) {
      const { email_address, ...errors } = this.state.errors;
      this.setState({ errors });
    } else {
      const errors = Object.assign(
        {},
        this.state.errors,
        { email_address: "Invalid format" },
      );
      this.setState({ errors });
    }
  }

  onChange = (field) => {
    return (e) => this.setState({ [field]: e.target.value });
  }

  onChangeEmail = (e) => {
    return this.setState(
      { email_address: e.target.value },
      this.validateEmail
    );
  }

  onChangeContact = () => {
    segmentEventTracker.trackEvent(TrackEventName.MODAL_SAVE_CLICKED);

    const successCallback = () => {
      this.setState({ submitting: false });
      closeModal();
    };

    const errorCallback = () => {
      this.setState({ submitting: false, is_duplicate_error: true });
    };

    this.setState({ submitting: true });

    if (this.state.id) {
      const newContact = Object.assign(
        {},
        this.newContact,
        { id: this.state.id },
      );

      this.props.onUpdateContact(
        this.state.id,
        newContact,
        () => {
          this.setState({ submitting: false });
          if(!this.props.tradeContacts.find((contact) => { return contact.id === this.state.id})) {
            this.props.onAddTradeContact()(newContact);
          }
          closeModal();
        },
        errorCallback,
      );
    } else {
      this.props.onAddContact(
        this.newContact,
        successCallback,
        errorCallback,
      );
    }
  }

  isButtonDisabled() {
    return !this.state.first_name ||
      !this.state.last_name ||
      !this.state.email_address ||
      !this.emailRegex.test(this.state.email_address) ||
      !this.state.work_contact_number ||
      this.state.submitting;
  }

  renderTextInput(label, name, value, placeholder, description = null, onChange, error) {
    return (
      <TextInput
        label={label}
        name={name}
        value={value || ""}
        placeholder={placeholder}
        onChange={onChange}
        error={error}
        tip={description}
      />
    );
  }

  renderNumberInput(label, name, value, placeholder, description = null, onChange, error) {
    return (
      <NumberInput
        label={label}
        name={name}
        value={value || ""}
        placeholder={placeholder}
        onChange={onChange}
        error={error}
        tip={description}
      />
    );
  }

  renderDeleteLink() {
    if (!this.state.id) return;

    return (
      <a
        data-testid='form-delete-contact'
        className="ds-btn _link -danger --small _right"
        onClick={this.props.onDeleteContact}
      >
        Delete Contact
      </a>
    );
  }

  renderSubmitText() {
    return this.state.submitting ? "Saving..." : "Save";
  }

  renderDuplicateError() {
    return (
      <div className="ds-notice -danger">
        <p className="copy">Contact is already existing.</p>
        <button
          className="ds-btn -secondary --micro"
          onClick={this.props.onTabClick(1)}
        >
          {`Check Existing ${this.props.contacts.length > 0 ? "Contacts" : "Contact"}`}
        </button>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        {this.state.is_duplicate_error && this.renderDuplicateError()}
        <section className="cardSection">
          <div className="ds-formGroup _noTopPadding">
            {this.renderTextInput(
              "First Name *",
              "first_name",
              this.state.first_name,
              "Enter First Name",
              null,
              this.onChange("first_name"),
              this.state.errors.first_name
            )}
            {this.renderTextInput(
              "Last Name *",
              "last_name",
              this.state.last_name,
              "Enter Last Name",
              null,
              this.onChange("last_name"),
              this.state.errors.last_name
            )}
          </div>
          <div className="ds-formGroup">
            {this.renderTextInput(
              "Work Email *",
              "email_address",
              this.state.email_address,
              "Enter Email Address",
              "e.g. example@company.ph",
              this.onChangeEmail,
              this.state.errors.email_address
            )}
            {this.renderNumberInput(
              "Personal Contact Number",
              "personal_contact_number",
              this.state.personal_contact_number,
              "Enter Personal Contact Number",
              "e.g. 0917 122 8899",
              this.onChange("personal_contact_number"),
              this.state.errors.personal_contact_number
            )}
          </div>

          <div className="ds-formGroup">
            {this.renderNumberInput(
              "Business Landline *",
              "work_contact_number",
              this.state.work_contact_number,
              "Enter Business Landline",
              "e.g. 02 388 4877",
              this.onChange("work_contact_number"),
              this.state.errors.work_contact_number
            )}
            {this.renderNumberInput(
              "Business Landline Ext",
              "work_contact_number_extension",
              this.state.work_contact_number_extension,
              "Enter Extension Number",
              "e.g. 127",
              this.onChange("work_contact_number_extension"),
              this.state.errors.work_contact_number_extension
            )}
          </div>

        </section>
        <section className="cardSection _navigation">
          <a
            data-testid='form-cancel'
            className="ds-btn _link -secondary --small"
            onClick={this.props.onTabClick(1)}
          >
            Cancel
          </a>
          {this.renderDeleteLink()}
          <button
            data-testid='form-save'
            className={this.saveButtonClassnames()}
            disabled={this.isButtonDisabled()}
            onClick={this.onChangeContact}
          >
            {this.renderSubmitText()}
          </button>
        </section>
      </Fragment>
    );
  }
}

export default ContactManagerFormContainer;



// WEBPACK FOOTER //
// ./src/features/contacts/components/FormContainer.js